import React from 'react'

import heroStyles from "./hero.module.css";

const HeroHeader = () => (
  <div className={heroStyles.main}></div>
)

export default HeroHeader
